import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import VideoTestimonials from "@/components/sections/VideoTestimonials";
import ReviewsStats from "@/components/sections/ReviewsStats";
import Services from "@/components/sections/Services";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

export default function Landing() {
  return (
    <div id="top" className="bg-white">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <VideoTestimonials />
      <ReviewsStats />
      <Contact />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
